import { createRouter, createWebHistory } from '@ionic/vue-router'
import { defineComponent, h } from 'vue'

const Empty = defineComponent({ render: () => h('div') })

const routes = [
  { path: '/', component: Empty },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router